import useScreen from '@lyearn/core/hooks/useScreen';
import { useTranslation } from '@lyearn/i18n';
import { Checkbox, Stack, Typography } from '@lyearn/ui';

import { SelectAllProps } from '../types';

const SelectAll = ({ state, onSelectAllClick }: SelectAllProps) => {
  const { t } = useTranslation();
  const { isMobile } = useScreen();

  return (
    <Stack
      alignItems="center"
      className="mx-8 mb-2 flex h-38 items-center px-12 xs:mx-12"
      justifyContent="between"
      onClick={() => {
        onSelectAllClick(state === 'some' || state === 'none' ? 'all' : 'none');
      }}>
      <Typography as="p" className="" color="text-text-placeholder" variant="label-caps">
        {t('Common:Filter.SelectAll')}
      </Typography>
      <Checkbox
        parent
        checked={state === 'some' ? undefined : state === 'all'}
        className={isMobile ? 'h-24 min-w-0 bg-bg-primary p-0' : undefined}
        indeterminate={state === 'some'}
        size={isMobile ? 'large' : undefined}
      />
    </Stack>
  );
};

export default SelectAll;
